<template>
    <div>
        <slot name="slot"></slot>
    </div>
</template>

<script>
import ResizeScale from '@/lib/resize-scale.js'

export default {
    name: 'ResizeScale',

    props: {
        noTransForm: {
            type: Boolean,
            default: false
        }
    },

    mounted: function() {
        setTimeout(() => {
            this.resizeScaleQuizFrame()
        }, 100)
    },

    methods: {
        resizeScaleQuizFrame () {
            const layoutElem = this.$slots.slot[0].elm
            const contentElem = layoutElem.getElementsByClassName('content-container')[0]
            const headerElem = layoutElem.getElementsByClassName('header')[0]
            const footerElem = layoutElem.getElementsByClassName('footer')[0]
            const headerHeight = typeof headerElem !== 'undefined' ? headerElem.getBoundingClientRect().height : 0
            const footerHeight = typeof footerElem !== 'undefined' ? footerElem.getBoundingClientRect().height : 0
            const uselessHeight = headerHeight + footerHeight

            layoutElem.style.setProperty('--useless-h', `${uselessHeight}px`)

            new ResizeScale({
                width: contentElem.getBoundingClientRect().width,
                height: contentElem.getBoundingClientRect().height,
                child: contentElem,
                parent: layoutElem,
                uselessHeight: uselessHeight,
                noTransForm: this.noTransForm
            })

            document.getElementById('app').classList.add('overflow-hidden')
            document.getElementById('app').classList.add('relative')
        },
    }
}
</script>

<style lang="scss" scoped>
.logo {
    @media (max-width: 767px) {
        display: inline-block;
        width: 15rem;
    }
}

.layout {
    height: calc(100vh - 2rem);
    height: calc((var(--vh, 1vh) * 100) - 2rem);
}

@media screen and (min-width: 768px) and (max-width: 1920px) {
    section.layout .content {
        overflow: hidden;
        height: calc(100% - var(--useless-h));
    }
}

@media screen and (min-width: 768px) {
    section.layout .content {
        // overflow-y: inherit;
        // overflow-x: inherit;
    }
}

@media screen and (max-width: 767px) {
    section.layout .content {
        overflow: hidden;
        height: calc(100% - var(--useless-h));
    }

    section.layout .footer {
        bottom: 0;
    }
}
</style>